import {
  doc,
  setDoc,
  updateDoc,
  deleteDoc,
  collection,
  query,
  where,
  Timestamp
} from 'firebase/firestore';
import { onSnapshotWithRetry as onSnapshot } from '../utils/firestoreSubscribe';
import { getDb } from '../firebase';

export const createActivity = async (familyId, activityData) => {
  const db = getDb();
  const ref = doc(collection(db, 'families', familyId, 'activities'));
  const data = {
    ...activityData,
    startDate: activityData.startDate || new Date().toISOString().split('T')[0],
    isActive: true,
    createdAt: Timestamp.now()
  };
  await setDoc(ref, data);
  return { id: ref.id, ...data };
};

export const updateActivity = async (familyId, activityId, updates) => {
  const db = getDb();
  await updateDoc(doc(db, 'families', familyId, 'activities', activityId), updates);
};

export const deleteActivity = async (familyId, activityId) => {
  const db = getDb();
  await deleteDoc(doc(db, 'families', familyId, 'activities', activityId));
};

export const addExcludedDate = async (familyId, activityId, dateStr, modifiedBy = null) => {
  const db = getDb();
  const ref = doc(db, 'families', familyId, 'activities', activityId);
  const { getDoc: gd } = await import('firebase/firestore');
  const snap = await gd(ref);
  if (!snap.exists()) return;
  const current = snap.data().excludedDates || [];
  if (!current.includes(dateStr)) {
    await updateDoc(ref, {
      excludedDates: [...current, dateStr],
      lastModifiedBy: modifiedBy,
      lastModifiedAt: Timestamp.now(),
      lastModifiedDate: dateStr,
      lastModifiedKind: 'excluded',
    });
  }
};

export const removeExcludedDate = async (familyId, activityId, dateStr) => {
  const db = getDb();
  const ref = doc(db, 'families', familyId, 'activities', activityId);
  const { getDoc: gd } = await import('firebase/firestore');
  const snap = await gd(ref);
  if (!snap.exists()) return;
  const current = snap.data().excludedDates || [];
  await updateDoc(ref, { excludedDates: current.filter(d => d !== dateStr) });
};

export const updateInstanceOverride = async (familyId, activityId, dateStr, overrideData, modifiedBy = null) => {
  const db = getDb();
  const ref = doc(db, 'families', familyId, 'activities', activityId);
  await updateDoc(ref, {
    [`instanceOverrides.${dateStr}`]: {
      ...overrideData,
      modifiedBy,
      modifiedAt: Timestamp.now(),
    },
    lastModifiedBy: modifiedBy,
    lastModifiedAt: Timestamp.now(),
    lastModifiedDate: dateStr,
    lastModifiedKind: 'override',
  });
};

export const subscribeToActivities = (familyId, callback) => {
  const db = getDb();
  const q = query(
    collection(db, 'families', familyId, 'activities'),
    where('isActive', '==', true)
  );
  return onSnapshot(q, (snapshot) => {
    const activities = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    callback(activities);
  }, (error) => {
    console.error('Activities listener error:', error);
  });
};
